var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrInvestAppstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillOpacity: 1,
      colorRendering: "auto",
      colorInterpolation: "auto",
      textRendering: "auto",
      stroke: "black",
      strokeLinecap: "square",
      strokeMiterlimit: 10,
      shapeRendering: "auto",
      strokeOpacity: 1,
      fill: "black",
      strokeDasharray: "none",
      fontWeight: "normal",
      strokeWidth: 1,
      fontFamily: "'Dialog'",
      fontStyle: "normal",
      strokeLinejoin: "miter",
      fontSize: 12,
      strokeDashoffset: 0,
      imageRendering: "auto"
    },
    width: 357,
    height: 357,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "genericDefs"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "white",
      textRendering: "optimizeLegibility",
      stroke: "white"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 357,
    height: 357,
    y: 0,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 4,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 4,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 4,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 4,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 4,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 4,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 16,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 16,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 16,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 16,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 16,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 16,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 16,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 16,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 28,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 28,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 28,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 28,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 28,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 28,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 28,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 40,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 40,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 40,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 40,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 40,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 40,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 52,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 52,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 52,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 52,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 52,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 52,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 64,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 64,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 64,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 64,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 64,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 64,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 76,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 76,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 76,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 76,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 76,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 76,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 76,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 88,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 88,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 88,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 88,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 88,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 88,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 88,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 88,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 88,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 88,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 100,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 112,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 124,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 136,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 148,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 148,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 148,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 148,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 148,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 148,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 148,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 148,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 160,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 172,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 184,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 196,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 208,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 220,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 232,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 244,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 256,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 256,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 256,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 256,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 256,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 256,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 256,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 268,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 268,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 268,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 268,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 268,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 268,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 268,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 268,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 268,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 268,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 268,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 280,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 292,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 304,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 304,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 304,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 304,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 304,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 304,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 304,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 304,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 304,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 316,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 316,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 316,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 316,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 316,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 316,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 316,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 316,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 316,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 316,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 316,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 328,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 328,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 328,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 328,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 328,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 328,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 328,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 328,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 340,
    width: 12,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 84,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 60,
    height: 60,
    y: 16,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 36,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 4,
    width: 84,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    width: 60,
    height: 60,
    y: 16,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 28,
    width: 36,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 268,
    width: 84,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 60,
    height: 60,
    y: 280,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 292,
    width: 36,
    style: {
      fill: "black",
      stroke: "none"
    },
    height: 36
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrInvestAppstore);
export default __webpack_public_path__ + "static/media/QR_invest_appstore.8bdf7cff75099ef37faa9416414070d7.svg";
export { ForwardRef as ReactComponent };